import getConfig from 'next/config'
const { publicRuntimeConfig } = getConfig()

export const IS_DEPLOYED = process.env.NODE_ENV === 'production'

export const BUILD_TAG = process.env.BUILD_TAG as string
export const BRANCH_NAME = process.env.BRANCH_NAME as string
export const SERVICE_NAME = process.env.SERVICE_NAME || 'cms'
export const ASSET_PREFIX = process.env.ASSET_PREFIX ?? ''

// Note: Public runtime config does not exist for static build: https://nextjs.org/docs/pages/api-reference/config/next-config-js/runtime-configuration

// For asset urls that occur at both runtime and build time, this defaults to CDN_URL at runtime and CDN_URL_TEMPLATE which needs to be string replaced at build time
export const CDN_URL_TEMPLATE = publicRuntimeConfig?.CDN_URL ?? process.env.CDN_URL_TEMPLATE ?? ''

export const CDN_URL = publicRuntimeConfig?.CDN_URL
export const GR_ENV = (publicRuntimeConfig?.GR_ENV ?? process.env.GR_ENV) as 'qa' | 'preprod' | 'prod'
export const CONTENTFUL_SPACE_ID = publicRuntimeConfig?.CONTENTFUL_SPACE_ID
export const CONTENTFUL_ENV_ID = publicRuntimeConfig?.CONTENTFUL_ENV_ID
